import React from 'react';

import { classNames } from '../../utils/style';
import { DefaultBsComponent } from '../../types/module';

export interface NavigationButtonProps extends DefaultBsComponent {
  onClick?: any;
}

export const NavigationButton = ({
  children,
  className,
  as: Component = 'button',
  onClick,
  ...props
}: NavigationButtonProps) => {
  const handle = (e: any) => {
    if ((e?.code !== 'Enter' && typeof e?.code !== 'undefined') || !onClick)
      return;
    onClick(e);
  };

  return (
    <Component
      className={classNames(
        'NavigationButton',
        className,
        'bg-white px-16 py-12 rounded-12 cursor-pointer',
        'transition-all duration-75 hover:shadow-navigationButton',
        'border',
        'box-border hover:border hover:border-blue-101',
        'flex gap-12 items-center',
        'text-neutral-301 text-16 leading-22 font-normal',
      )}
      onClick={handle}
      onKeyDown={handle}
      {...props}
    >
      {children}
    </Component>
  );
};
